export const calculateSupplyAndExhaustFlow = (houseVolume, achValue) => {
    const slope = 0.27784 * houseVolume - 0.014;
    //const intercept = (-0.00028) * houseVolume + 0.06;

    const calculatedSupply = parseFloat((slope * achValue + 0).toFixed(2));
    const calculatedExhaust = calculatedSupply;

    return {
        supply: calculatedSupply,
        exhaust: calculatedExhaust,
    };
};

const DEFAULT_FLOW_RATES = {
    hrv: {
        wholeHouse: { house: 28, murb: 22 },
        supplemental: { house: 28, murb: 28 },
    },
    dryer: {
        supplemental: { house: 38, murb: 38 },
    },
    rangeHood: {
        wholeHouse: { house: 75, murb: 75 },
        supplemental: { house: 75, murb: 75 },
    },
    bathroom: {
        wholeHouse: { house: 33, murb: 33 },
        supplemental: { house: 33, murb: 33 },
    },
    utility: {
        wholeHouse: { house: 25, murb: 25 },
        supplemental: { house: 25, murb: 25 },
    },
};

export const getMurbUnitCount = ({ buildingTypeId = 0, numDwellingUnits = 1, numNonResUnits = 0 }) =>
    buildingTypeId === 2
        ? Math.max(1, (Number(numDwellingUnits) || 0) + (Number(numNonResUnits) || 0))
        : 1;

export const getDefaultVentilatorValues = ({
    type,
    isSupplemental = false,
    buildingTypeId = 0,
    numDwellingUnits = 1,
    numNonResUnits = 0,
}) => {
    const section = isSupplemental ? "supplemental" : "wholeHouse";
    const building = buildingTypeId === 0 ? "house" : "murb";
    const unitCount = getMurbUnitCount({ buildingTypeId, numDwellingUnits, numNonResUnits });
    const flowRate = (DEFAULT_FLOW_RATES[type]?.[section]?.[building] || 0) * unitCount;

    if (type === "hrv") {
        const totalFlow = flowRate * 2;
        const fanPower1 = 0.0034494 * totalFlow ** 2 + 0.391808151 * totalFlow + 27.0046226;
        const fanPower2 = 0.002599021 * totalFlow ** 2 + 0.667954071 * totalFlow + 27.98485337;

        return {
            supplyFlowrate: flowRate,
            exhaustFlowrate: flowRate,
            fanPower1: parseFloat(fanPower1.toFixed(1)),
            fanPower2: parseFloat(fanPower2.toFixed(1)),
            isDefaultFanpower: true,
        };
    }

    return {
        supplyFlowrate: 0,
        exhaustFlowrate: flowRate,
        fanPower1: type === "dryer" ? 0 : parseFloat((flowRate * 0.76).toFixed(2)),
        isDefaultFanpower: true,
    };
};